module.exports = __webpack_public_path__ + "img/dave-headshot.ec58ae83.png";